import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles/index';

const styles = () => ({
    buttonDefault: {
        borderRadius: 3,
        border: 0,
        color: '#363636',
        height: 36,
        padding: '0 10px',
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.12)',
    },
    buttonSelected: {
        borderRadius: 3,
        border: 0,
        color: '#ff4700',
        height: 36,
        padding: '0 10px',
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.12)',
        '&:hover': {
            color: '#ffffff',
        },
    },
});

function WhiteButton(props) {
    const {
        isSelected,
        onClick,
        ...other
    } = props;
    return (
        <Button
            {...other}
            color={isSelected ? 'primary' : 'default'}
            classes={{
                root: isSelected ? props.classes.buttonSelected : props.classes.buttonDefault,
            }}
            onClick={onClick}
        >
            {isSelected ? 'selected' : 'select'}
        </Button>
    );
}

WhiteButton.propTypes = {
    classes: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(WhiteButton);



// WEBPACK FOOTER //
// ./src/app/common/components/Buttons/WhiteButton.js